import './BreachIgnition.css';

const BreachIgnition = () => (
  <div className="coreboundBreachIgnition" aria-hidden="true">
    <div className="coreboundBreachPortalGlow" />
    <svg viewBox="0 0 360 250" fill="none">
      <ellipse
        className="coreboundBreachShockwave"
        cx="180"
        cy="125"
        rx="90"
        ry="90"
      />
      <g className="coreboundBreachPortalRings">
        <circle cx="180" cy="125" r="103" />
        <circle cx="180" cy="125" r="89" />
        <circle cx="180" cy="125" r="112" />
      </g>
      <path
        className="coreboundBreachPortalAperture"
        d="M180 42 219 125 180 208 141 125Z"
      />
      <path className="coreboundBreachPortalSeam" d="M180 53v144" />
      <g className="coreboundBreachPortalDebris">
        {Array.from({ length: 12 }, (_, index) => (
          <path
            key={index}
            d="M180 11v9l5 5"
            transform={`rotate(${index * 30} 180 125)`}
          />
        ))}
      </g>
    </svg>
    <span className="coreboundBreachPortalLabel">PORTAL NETWORK RESTORED</span>
  </div>
);

export default BreachIgnition;
